var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4D55",
    fillRule: "evenodd",
    d: "M10 3.75c.69 0 1.25.56 1.25 1.25v3.75H15a1.25 1.25 0 1 1 0 2.5h-3.75V15a1.25 1.25 0 1 1-2.5 0v-3.75H5a1.25 1.25 0 1 1 0-2.5h3.75V5c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon2);
export default __webpack_public_path__ + "static/media/plus-icon2.2b9b376e7bbafb1427426c0ffd19005d.svg";
export { ForwardRef as ReactComponent };